import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import * as _ from 'lodash';
import { highlightPlaceholders } from '~/assets/helper/functions';
import { useListQuestionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Questions',
  props: {
    value: null,
    modelValue: null,
    disabled: {
      type: Boolean
    },
    columns: null,
    defaultFilters: null,
    showSelect: {
      type: Boolean
    },
    mergeTemplateTexts: {
      type: Boolean
    }
  },
  emits: ['input', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;

    // Set default values
    var _props$value = props.value,
      value = _props$value === void 0 ? [] : _props$value,
      modelValue = props.modelValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? ['id', 'ixId', 'label', 'sublabel', 'tooltip', 'component', 'isMandatory', 'isMultiple', 'scoringRules', 'sort', 'actions'] : _props$columns,
      _props$defaultFilters = props.defaultFilters,
      defaultFilters = _props$defaultFilters === void 0 ? null : _props$defaultFilters,
      _props$showSelect = props.showSelect,
      showSelect = _props$showSelect === void 0 ? true : _props$showSelect,
      _props$mergeTemplateT = props.mergeTemplateTexts,
      mergeTemplateTexts = _props$mergeTemplateT === void 0 ? false : _props$mergeTemplateT;
    var currentIds = computed(function () {
      return (modelValue !== undefined ? modelValue : value) || [];
    });
    var route = useRoute();
    var router = useRouter();
    var headers = computed(function () {
      return [{
        value: 'id',
        sortable: false
      }, {
        value: 'label',
        cellClass: 'max-w-[200px]'
      }, {
        value: 'sublabel',
        cellClass: 'max-w-[200px]'
      }, {
        value: 'tooltip',
        cellClass: 'max-w-[400px]'
      }, {
        value: 'isMandatory'
      }, {
        value: 'isMultiple'
      }, {
        value: 'templateTexts',
        cellClass: 'max-w-[400px]'
      }, {
        value: 'scoringRules',
        cellClass: 'max-w-[400px]'
      }, {
        value: 'sort'
      }, {
        value: 'actions'
      }].filter(function (o) {
        return columns === null || columns === void 0 ? void 0 : columns.includes(o.value);
      }).map(function (col) {
        return _objectSpread(_objectSpread({}, col), {}, {
          sortable: col.sortable || false
        });
      }) || [];
    });

    // Initialize options with URL query parameters
    var options = ref({
      page: parseInt(route.query.page) || 1,
      itemsPerPage: parseInt(route.query.itemsPerPage) || 10,
      sortDesc: [true]
    });
    var variables = computed(function () {
      return {
        filters: _objectSpread(_objectSpread({}, defaultFilters), {}, {
          text: route.query.text || ''
        }),
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });

    // Handle search input and update URL
    var handleSearchInput = function handleSearchInput(value) {
      var query = _objectSpread({}, route.query);
      if (value) {
        query.text = value;
      } else {
        delete query.text;
      }
      query.page = '1'; // Reset to page 1 when searching

      router.push({
        query: query
      });
    };

    // Watch options changes and update URL
    watch(options, function (newOptions) {
      var query = _objectSpread({}, route.query);
      query.page = newOptions.page.toString();
      query.itemsPerPage = newOptions.itemsPerPage.toString();
      router.push({
        query: query
      });
    }, {
      deep: true
    });
    var _useListQuestionsQuer = useListQuestionsQuery(variables),
      result = _useListQuestionsQuer.result,
      refetch = _useListQuestionsQuer.refetch;
    var items = computed(function () {
      var _result$value$listQue, _result$value;
      return (_result$value$listQue = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listQuestions) !== null && _result$value$listQue !== void 0 ? _result$value$listQue : [];
    });
    var selected = computed(function () {
      return items === null || items === void 0 ? void 0 : items.value.filter(function (question) {
        return currentIds.value.filter(Boolean).includes(question.id);
      });
    });
    var onInput = function onInput(val) {
      var nextIds = val.map(function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      if (_.isEqual(nextIds, currentIds.value)) {
        return;
      }
      emit('update:modelValue', nextIds);
      emit('input', nextIds);
    };
    var loading = useQueryLoading();
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countQuestions) || 0;
    });
    return {
      __sfc: true,
      props: props,
      value: value,
      modelValue: modelValue,
      disabled: disabled,
      columns: columns,
      defaultFilters: defaultFilters,
      showSelect: showSelect,
      mergeTemplateTexts: mergeTemplateTexts,
      emit: emit,
      currentIds: currentIds,
      route: route,
      router: router,
      headers: headers,
      options: options,
      variables: variables,
      handleSearchInput: handleSearchInput,
      result: result,
      refetch: refetch,
      items: items,
      selected: selected,
      onInput: onInput,
      loading: loading,
      itemCount: itemCount,
      highlightPlaceholders: highlightPlaceholders
    };
  }
});